import { createContext, useContext, ReactNode } from 'react';
import { Asset } from '../state/types'; // Make sure the path to your types is correct
import { ImageCategory, useAssetState } from '../hooks/asset/useAssetState';
import { State } from '../state/reducers';
import { useSelector } from 'react-redux';

// Define the shape of the context data
export interface AssetContextType {
  asset: Asset | null;
  assetId?: string;
  clientId?: string;
  user: any;
  loading: boolean;
  errors: any[];
  visibleTypes: { [key: string]: boolean };
  setVisibleTypes: React.Dispatch<React.SetStateAction<{ [key: string]: boolean }>>;
  imageCategories: ImageCategory[];
  isEditAssetIdModalOpen: boolean;
  openEditAssetIdModal: () => void;
  closeEditAssetIdModal: () => void;
  isEditAssetModalOpen: boolean;
  openEditAssetModal: () => void;
  closeEditAssetModal: () => void;
}

// Create the context with a default value of null
export const AssetContext = createContext<AssetContextType | null>(null);

export const AssetProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const assetState = useAssetState();
  const user = useSelector((state: State) => state.accountState.user);

  const value: AssetContextType = {
    ...assetState,
    user,
  };

  return (
    <AssetContext.Provider value={value}>
      {children}
    </AssetContext.Provider>
  )
};

// Custom hook for consuming the context
export const useAsset = (): AssetContextType => {
  const context = useContext(AssetContext);
  if (!context) {
    throw new Error('useAsset must be used within a AssetProvider');
  }
  return context;
};